module.exports = __webpack_public_path__ + "img/exercise3.52770bd2.svg";